import { Theme, useMediaQuery } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { EntityPickerPopover } from '@work4all/components/lib/components/entity-picker/components';
import {
  DatevTenantPicker,
  IDatevTenantPickerProps,
} from '@work4all/components/lib/components/entity-picker/datev-tenant-picker/DatevTenantPicker';

import { PickerTargetButton } from '../../containers/mask-overlays/locked-inputs';

interface DatevTenantPickerFieldProps
  extends Omit<IDatevTenantPickerProps<false>, 'multiple'> {
  error?: string;
  name?: string;
  label?: string;
  required?: boolean;
}

export const DatevTenantPickerField = React.forwardRef<
  HTMLDivElement,
  DatevTenantPickerFieldProps
>(function DatevTenantPickerField(props, ref) {
  const {
    error,
    favorites = true,
    label,
    prefilter,
    required,
    ...pickerProps
  } = props;
  const { value, onChange, clearable } = pickerProps;

  const { t } = useTranslation();

  const resultingLabel = label || t('COMMON.DATEVTENANT');

  const isMobile = useMediaQuery<Theme>((theme) =>
    theme.breakpoints.down('sm')
  );

  return (
    <EntityPickerPopover
      fullscreen={isMobile}
      picker={
        <DatevTenantPicker
          multiple={false}
          prefilter={prefilter}
          favorites={favorites}
          {...pickerProps}
        />
      }
    >
      <PickerTargetButton
        ref={ref}
        value={value ? value?.name : ''}
        name={props.name}
        label={resultingLabel}
        error={error}
        onClear={
          clearable
            ? () => {
                onChange(null);
              }
            : undefined
        }
        required={required}
      />
    </EntityPickerPopover>
  );
});
